import { EOL } from "os";

import type { OpenApi } from "../../types";

import { Name, Version } from "../../meta";

export const generateLeading = (schema: OpenApi.Document): string => {
  const messages: string[] = [];
  messages.push("");
  messages.push(`Generated by ${Name} v${Version}`);
  messages.push("");
  messages.push(`OpenApi : ${schema.openapi}`);
  messages.push("");
  if (schema.info.license) {
    if (schema.info.license.name) {
      messages.push(`License  : ${schema.info.license.name}`);
    }
    if (schema.info.license.url) {
      messages.push(`Url      : ${schema.info.license.url}`);
    }
  }
  messages.push("");
  return messages
    .map(message => {
      return `// ${message}`;
    })
    .join(EOL);
};
